<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog @keydown.enter="login" max-width="450" persistent v-model="$store.getters.loginModal">
            <v-card>
                <v-card-title class="white--text primary">
                    <h4>Είσοδος</h4>
                </v-card-title>
                <br/>
                <v-form class="mx-2">
                    <v-row justify="center"  class="mx-auto">
                        <v-chip v-if="errorMessageFlag"  color="error">{{errorMessage}}</v-chip>
                    </v-row>
                    <v-text-field :error="errorMessageFlag" v-model="username" label="Όνομα Χρήστη" name="Username" prepend-icon="person"></v-text-field>
                    <v-text-field :error="errorMessageFlag" v-model="password" label="Κωδικός Πρόβασης" name="Password" prepend-icon="lock" type="password"></v-text-field>
                    <v-card-actions>
                        <v-btn block class="white--text" color="primary" large primary @click="login()">ΣΥΝΔΕΣΗ</v-btn>
                    </v-card-actions>
                    <v-card-subtitle>
                        <p subtitle-2>Σε περίπτωση που ξεχάσατε το password πατήστε <a
                                href="https://submit.eudoxus.gr/">εδώ</a>.</p>

                    </v-card-subtitle>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import requests from '../requests'
    import utils from '../utilities'
    import {eventBus} from "../main";

    export default {
        name: "LoginModal",
        data() {
            return {
                dialog: true,
                username: '',
                // username: 'Matoula',
                password: '',
                errorMessageFlag: false,
                errorMessage: '',
                homeInformaton: {}
            }
        },
        methods: {
            login() {
                if (this.validateTextField()) {
                    this.$store.commit('setLoadingModal', true);
                    requests.login(this.username, this.password , this.loginCallBack, this.failedLoginCallBack);
                }
            },

            loginCallBack(response){

                this.errorMessageFlag = false;
                this.errorMessage = '';
                var token = response;
                    utils.setLocalStorage('token', response);
                if (response == '') {//is not connected
                    this.errorMessage = 'Username or Password is incorrect';
                    this.errorMessageFlag = true;
                    this.$store.commit('setLoadingModal', false);
                }
                else {//connected
                    requests.homePageInformation(token, this.homePageInformationCallBack);
                    requests.get('rest/user/prefectures', (resp)=>{
                        this.$store.commit('setPrefectures', resp);
                    })
                }
            },

            failedLoginCallBack(response){
                this.errorMessageFlag = true;
                this.errorMessage = response;
            },

            homePageInformationCallBack(response) {
                utils.checkIfAllocator(response);
                this.homeInformaton = response;
                console.log(response.bookInfoAlert)
                console.log(this.$store.getters.bookInfoAlert)
				// if(response.bookInfoAlert===true){
				// 	console.log('inside')
				// 	this.$store.commit('setBookInfoAlert', true);
				// }else{
					this.$store.commit('setBookInfoAlert', response.bookInfoAlert);
                // }
                requests.getYears(utils.getLocalStorage('token'), this.getYearsCallBack);
                this.$store.commit('setHomePageInformation', response);

            },

            getYearsCallBack(response) {

                // var dataYear = [];
                // for (var i = 0;i < response.eudoxusPeriodDTOList.length; i++) {
                //     dataYear.push(response.eudoxusPeriodDTOList[i].year)
                // }
                // this.$router.push({path: '/'});


                var setYears = [];
                var years = response.yearsMapResp;
                for (var year in years) {
                    setYears.push(
                        {label: years[year],
                            value: Number(year)}
                    )
                }
                setYears.reverse();
                this.$store.commit('setActiveYear', response.activeYear);
                this.$store.commit('setEditedYear', response.editedYear);
                this.$store.commit('setYears', setYears);
                this.$store.commit('setYearsFixed', response.yearsList);
                // this.$store.commit('setAcademicYears', dataYear);
                this.$store.commit('setloginModal', false);
                this.$store.commit('setLoadingModal', false);
                this.username = '';
                this.password = '';
                utils.checkpublisherHistory(this.homeInformaton);
                eventBus.$emit('reCreateNavigationPath');
            },

            validateTextField() {
                this.errorMessageFlag = false;
                this.errorMessage = '';

                if (this.username.trim() == '') {
                    this.errorMessage = 'Username';
                    this.errorMessageFlag = true;
                }
                if (this.password.trim() == '') {

                    if (this.errorMessage != '') {
                        this.errorMessage += ' and Password';
                    }
                    else {
                        this.errorMessage = 'Password'
                    }
                    this.errorMessageFlag = true;
                }
                if (this.errorMessageFlag) {
                    this.errorMessage += ' is Required';
                    return false;
                }
                return true;
            }
        }
    }
</script>

<style scoped>
   
</style>